"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("g", { clipPath: "url(#clip0)" },
        react_1.default.createElement("path", { stroke: "#5E6D7A", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", d: "m14.625 1.125-12 13.5h9l-1.5 9 12-13.5h-9l1.5-9Z" })),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("clipPath", { id: "clip0" },
            react_1.default.createElement("path", { d: "M0 0h24v24H0z" })))), 'SpeedDialIcon');
